/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiTransliterationRequest
 */
export interface InternalApiTransliterationRequest {
    /**
     * The text to be transliterated
     * @type {string}
     * @memberof InternalApiTransliterationRequest
     */
    text: string;
    /**
     * List of feature flags to control transliteration behavior
     * @type {Array<InternalApiTransliterationRequestFeaturesEnum>}
     * @memberof InternalApiTransliterationRequest
     */
    features: Array<InternalApiTransliterationRequestFeaturesEnum>;
}

/**
* @export
* @enum {string}
*/
export enum InternalApiTransliterationRequestFeaturesEnum {
    CHINESE_SUPPORT = 'CHINESE_SUPPORT',
    CHINESE_SUPPORT_EXTENSION_WORD_BOUNDARY_DETECTION = 'CHINESE_SUPPORT_EXTENSION_WORD_BOUNDARY_DETECTION',
    CYRILLIC_SUPPORT = 'CYRILLIC_SUPPORT',
    GREEK_SUPPORT = 'GREEK_SUPPORT',
    BULGARIAN_SUPPORT = 'BULGARIAN_SUPPORT',
    MACEDONIAN_SUPPORT = 'MACEDONIAN_SUPPORT'
}


/**
 * Check if a given object implements the InternalApiTransliterationRequest interface.
 */
export function instanceOfInternalApiTransliterationRequest(value: object): value is InternalApiTransliterationRequest {
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('features' in value) || value['features'] === undefined) return false;
    return true;
}

export function InternalApiTransliterationRequestFromJSON(json: any): InternalApiTransliterationRequest {
    return InternalApiTransliterationRequestFromJSONTyped(json, false);
}

export function InternalApiTransliterationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiTransliterationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
        'features': json['features'],
    };
}

export function InternalApiTransliterationRequestToJSON(json: any): InternalApiTransliterationRequest {
    return InternalApiTransliterationRequestToJSONTyped(json, false);
}

export function InternalApiTransliterationRequestToJSONTyped(value?: InternalApiTransliterationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'features': value['features'],
    };
}

